module.exports = __webpack_public_path__ + "static/img/pc_record_bg.0c0cc5cf.png";